"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var r = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var r__default = /*#__PURE__*/_interopDefaultLegacy(r);

var t=r__default["default"].div`
  display: flex;
  gap: var(--spacing-regular);
`,p={ButtonGroup:t};

exports.a = t;
exports.b = p;
